import {
    GoodPersonalEmails,
    StudentEmailDomains,
    StudentAndThrowawayDomains
} from "@functions/sales-funnel/constants";

const EmailRegex =
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

export function isValidEmail(email: string): boolean {
    return EmailRegex.test(email);
}

export function areValidEmails(emailsToValidate: string[]): boolean {
    if (!emailsToValidate || !emailsToValidate.length) {
        return false;
    }
    return emailsToValidate
        .map((e) => e.trim())
        .filter((e) => e)
        .every((email) => isValidEmail(email));
}

export function removeEmailsWithDisposableDomains(emails: string[]): string[] {
    // When importing with require(), use .default unless "esModuleInterop" is enabled.
    const { default: DisposableEmailsDomains } = require("./disposableEmailDomains");
    return emails.filter((e) => !DisposableEmailsDomains.includes(e.split("@")[1]));
}

export function splitEmails(emails: string): string[] {
    if (!emails) return [];

    let emailsArray = emails
        .toLowerCase()
        .split(/[,\s\n]+/)
        .filter((e) => e)
        .map((e) => e.trim())
        .filter((e) => !!e);
    return _.uniq(emailsArray);
}

export function getEmailType(email: string): string {
    if (!email) return "";

    const domain = email.split("@")[1].toLowerCase();
    const hasBusinessEmail = !(domain in StudentAndThrowawayDomains);
    const hasGoodPersonalEmail = GoodPersonalEmails.some((g) => email.includes(g));
    let emailType = "Personal";
    if (StudentEmailDomains.some((e) => email.includes(e))) {
        emailType = "Student";
    } else if (hasBusinessEmail && !hasGoodPersonalEmail) {
        emailType = "Business";
    }
    return emailType;
}
